import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
const SecondarySidebarLayout = ({ sidebar, children, onRight, width, fullWidthOnMobile, hideAtBreakpoint, className, }) => {
    if (!sidebar) {
        return children;
    }
    const safeWidth = width == null ? 300 : width;
    if (onRight) {
        return (_jsxs("div", { style: { position: "relative" }, children: [_jsx("div", { className: classNames({
                        [`mr-lt-${hideAtBreakpoint || ""}-0`]: hideAtBreakpoint,
                    }), style: { marginRight: safeWidth }, children: children }), _jsx("div", { className: classNames("h-100", {
                        "d-none": hideAtBreakpoint,
                        [`d-${hideAtBreakpoint || ""}-block`]: hideAtBreakpoint,
                    }), style: {
                        width: safeWidth,
                        position: "absolute",
                        right: 0,
                        top: 0,
                        bottom: 0,
                    }, children: sidebar })] }));
    }
    return (_jsxs("div", { children: [fullWidthOnMobile ? (_jsx("div", { className: "secondary-sidebar-container", style: { top: 0, bottom: 0 }, children: sidebar })) : (_jsx("div", { style: { width: safeWidth, top: 0, bottom: 0 }, children: sidebar })), _jsx("div", { style: { marginLeft: safeWidth }, children: children })] }));
};
export default SecondarySidebarLayout;
